<template>
    <v-btn
        :color="color"
        :block="block"
        :large="large"
        :small="small"
        :outlined="outlined"
        @click="logout"
        class="normal-btn"
    >
        <v-icon left>mdi-logout</v-icon>
        {{ $t('entrance.logout') }}
    </v-btn>
</template>

<script>

import firebase from 'firebase/app'
import 'firebase/auth'

export default {
    props: {
        color: {
            type: String,
            default: 'error'
        },
        block: {
            type: Boolean,
            default: false
        },
        outlined: {
            type: Boolean,
            default: false
        },
        small: {
            type: Boolean,
            default: false
        },
        large: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        async logout() {
            const vm = this
            await firebase.auth().signOut()
            await vm.$router.replace({name: 'login'})
        },
    },
}
</script>
